module.exports = __webpack_public_path__ + "static/media/product-8.84f4d076.png";